import axios from 'axios';
import Swal from 'sweetalert2';

const md = require('markdown-it')({
    linkify: true,
    typographer: true
});

export const dashboardMethodMainFunc = {
    submit_form(e) {
        e.preventDefault();
        // console.log(this.withUpdates.length);

        // if (this.withUpdates.length != 0) {
        //     Swal.fire({
        //         title: 'BOOK UPDATE',
        //         icon: 'info',
        //         html:
        //           'Please <b>update this book</b> before submitting this tile. <br>' +
        //           'Tap <img src="data:image/png;base64,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" style="height: 30px;" class="inline">' +
        //           ' beside the book title to update or click the "Update" button below.',
        //         showCloseButton: false,
        //         showDenyButton: true,
        //         confirmButtonText: 'Update',
        //         denyButtonText: 'Cancel',
        //         focusConfirm: false,
        //       }).then((result) => {
        //         /* Read more about isConfirmed, isDenied below */
        //         if (result.isConfirmed) {
        //             this.selectBook(this.$store.getters.selected_book)
        //         } else if (result.isDenied) {
        //           Swal.fire('Changes are not saved', '', 'info')
        //         }
        //       })
        // } else {
            var go_proceed = true;
            var proceed_form = true;

            if (Object.keys(this.validation).length > 0) {
                for (let [key] of Object.entries(this.validation)) {
                    var proceed_bp = true;
                    if (this.validation[key].condition == 'badgepack') {

                            for(var i = 0; i < this.bp_integration.length; i++) {
                                if (this.bp_integration[i].is_checked == 'no') {

                                    proceed_bp = false;

                                    var index_id = this.obj.html.indexOf("id='validator_"+key+"'");

                                    var first_close = this.obj.html.indexOf("validator_", index_id);
                                    var second_close = this.obj.html.indexOf("'", first_close);
                                    var get_closing_tag = this.obj.html.indexOf(">", second_close);
        
        
                                    this.obj.html = this.obj.html.slice(0, second_close+1) +this.obj.html.slice(get_closing_tag);

                                    break;
                                }
                            }
                    } else {
                        if (this.validation[key].condition_met == false) {
                            proceed_form = false
                           
                            index_id = this.obj.html.indexOf("id='validator_"+key+"'");

                            first_close = this.obj.html.indexOf("validator_", index_id);
                            second_close = this.obj.html.indexOf("'", first_close);
                            get_closing_tag = this.obj.html.indexOf(">", second_close);

                            // console.log(this.obj.html.substring(second_close, get_closing_tag));

                            this.obj.html = this.obj.html.slice(0, second_close+1) +this.obj.html.slice(get_closing_tag);

                        } else {
                            index_id = this.obj.html.indexOf("id='validator_"+key+"'");

                            first_close = this.obj.html.indexOf("validator_", index_id);
                            second_close = this.obj.html.indexOf("'", first_close);
                            get_closing_tag = this.obj.html.indexOf(">", second_close);

                            // console.log(this.obj.html.substring(second_close, get_closing_tag));

                            this.obj.html = this.obj.html.slice(0, second_close+1) +" class='hidden'"+this.obj.html.slice(get_closing_tag);
                        }
                    }

                    if (proceed_bp == true && proceed_form == true) {
                        go_proceed = true;
                    } else {
                        go_proceed = false;
                    }
                    
                }
            }

            if (go_proceed == true) {
                
                if (this.$store.getters.active_tile.safety_send == "yes") {
                    Swal.fire({
                        title: this.$store.getters.active_tile.safety_send_message,
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        denyButtonText: `Don't save`,
                        confirmButtonColor: "#145DA0"
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                        Swal.fire('Saved!', '', 'success')
                        
                        this.prepare_json_submit();
                        } else {
                        Swal.fire({title: 'Sending cancelled', icon: 'info', confirmButtonText: 'Okay'})
                        }
                    })
                } else {  /////////////////// NO SAFETY SEND
                    this.prepare_json_submit();
                }
            
             } else {
                this.$moshaToast("Please meet the required conditions.", { type: "danger" });
             }
        // }
       
        
    },

    prepareObj() {
         if (this.$store.getters.active_tile) {
            this.$store.getters.active_tile.tile_options.map((tiles) => {
                if (tiles.syntax === "selectbox") {
                        if (tiles.json['option-type'] === "url") {
                                    var url = '';
                                    url = tiles.json.url;

                                    this.prepObjStatus = false;

                                    if (url.includes('badgepack')) {
                                        var reg = new RegExp(/\{\{(.*?)\}\}/g);
                                        var matches = tiles.json.url.match(reg);
                                        var found;
                                        if (matches) {
                                            for(var i = 0; i < matches.length; i++) {
                                                reg = new RegExp(/\{\{(.*?)\}\}/g);
                                                found = reg.exec(matches[i]);
                
                                                var startIndexOf = url.indexOf(found[0]);
                                                var endIndexOf = startIndexOf+found[0].length;
                
                                                //now find in DYNAMIC MERGECODES IF EXIST
                                                url = url.slice(0, startIndexOf) + this.$store.getters.auth_user +  url.slice(endIndexOf);
                                            }
                                        }
                                        return axios({
                                            method: "get",
                                            url: url,
                                            headers: { Authorization: "Bearer "+this.badgepack_token }
                                        })
                                        .then(response => {
                                            tiles.json.option_label = [];
                                            tiles.json.option_value = [];

                                            this.bp_integration = [];

                                            for(var i = 0; i < response.data.data.badge_checklist.length; i++) {
                                                tiles.json.option_label.push(response.data.data.badge_checklist[i].title);
                                                tiles.json.option_value.push(response.data.data.badge_checklist[i].integration_link);
                                                if (response.data.data.badge_checklist[i].user_checklists[0]) {
                                                    this.bp_integration.push({
                                                        title: response.data.data.badge_checklist[i].title,
                                                        allow_user:  response.data.data.badge_checklist[i].meta.allow_user,
                                                        is_checked: response.data.data.badge_checklist[i].user_checklists[0].is_checked,
                                                        type: response.data.data.badge_checklist[i].type,
                                                        integration_link: response.data.data.badge_checklist[i].integration_link
                                                    }) 
                                                } else {
                                                    this.bp_integration.push({
                                                        title: response.data.data.badge_checklist[i].title,
                                                        allow_user:  response.data.data.badge_checklist[i].meta.allow_user,
                                                        is_checked: 'no',
                                                        type: response.data.data.badge_checklist[i].type,
                                                        integration_link: response.data.data.badge_checklist[i].integration_link
                                                    })
                                                }
                                                
                                                if (i == response.data.data.badge_checklist.length-1) {
                                                    // console.log("prepStat = true");
                                                    this.prepObjStatus = true;
                                                }
                                            }

                                           
                                        });   
                                    } else {
                                        // console.log("nagkarga");
                                            reg = new RegExp(/\{\{(.*?)\}\}/g);
                                            matches = tiles.json.url.match(reg);
                                            found;
                                            if (matches) {
                                                for(i = 0; i < matches.length; i++) {
                                                    reg = new RegExp(/\{\{(.*?)\}\}/g);
                                                    found = reg.exec(matches[i]);
                    
                                                    startIndexOf = url.indexOf(found[0]);
                                                    endIndexOf = startIndexOf+found[0].length;
                    
                                                    //now find in DYNAMIC MERGECODES IF EXIST
                                                    if (this.dynamic_mergecodes[found[1]]) {
                                                        url = url.slice(0, startIndexOf) + this.dynamic_mergecodes[found[1]] +  url.slice(endIndexOf);
                                                    }
                                                }
                                            }
                                            return axios({
                                                method: "get",
                                                url: tiles.json.url,
                                            })
                                            .then(response => {
                                                tiles.json.option_label = [];
                                                tiles.json.option_value = [];

                                                // console.log(response.data.length);
                                                
                                                for(var i = 0; i < response.data.length; i++) {
                                                    // if (response.data.some(e => e.Name === 'ListValue')) {
                                                         // console.log(response.data[i].ListName);
                                                    if (response.data[i].ListName != undefined || response.data[i].ListValue != undefined) {

                                                        var clean_name = response.data[i].ListName.replace(/'/g, "");
                                                        var clean_value = response.data[i].ListValue.replace(/'/g, "");
                                                        
                                                        tiles.json.option_label.push(clean_name);
                                                        tiles.json.option_value.push(clean_value);
                                                        // console.log("i: "+i);
                                                    }
                                                   
                                                    // }
                                                   

                                                    if (i ==  response.data.length-1) {
                                                        // console.log("prepStat = true");
                                                        this.prepObjStatus = true;
                                                    }
                                                }
                                            });
                                    }
            
                                    
                        }
                    // console.log("Prepare: "+tiles.json.option_label.length);
                }
                if (tiles.syntax === "msgbox") {
                    if (tiles.json.message_type === "URL") {
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                       
                        url = tiles.json.url;

                        reg = new RegExp(/\{\{(.*?)\}\}/g);
                        matches = tiles.json.url.match(reg);
                        found;
                        url;

                        if (matches) {
                                found = reg.exec(tiles.json.url);
                                // console.log(tiles.json.tag_name);
                                if (this.dynamic_mergecodes[found[1]]) {
                                    url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                                    this.dynamic_mergecodes[tiles.json.tag_name] = url;
                                }
                        } else {
                            this.dynamic_mergecodes[tiles.json.tag_name] = url;
                        }

                        if (tiles.json.url.includes('uberlist')) {
                            var settings = {
                                "url": this.dynamic_mergecodes[tiles.json.tag_name],
                                "mode": 'cors',
                                "method": "GET",
                                "timeout": 0,
                            };

                            this.message_url = {};
                            axios(settings)
                                .then((response) => {
                                    if (response.data[0].ListMemo == null) {
                                        this.message_url[tiles.json.tag_name] = response.data;
                                    } else {
                                        this.message_url[tiles.json.tag_name] = response.data[0].ListMemo;
                                    }
                                })
                                .catch((error) => {
                                    return error;
                                });
                        } else {
                            this.message_url[tiles.json.tag_name] = this.dynamic_mergecodes[tiles.json.tag_name];
                        }
                    }
                }
                // if (tiles.syntax === "camera") {
                   
                // }

            });
         }
    },

    getHtml() {
    
    var today = new Date();
    var str;
    this.validation = {};

    if (this.$store.getters.active_tile != null) {
        if (this.$store.getters.active_tile.tile_options.length > 0) {
            
            // this.tile_loaded = true;
            return this.$store.getters.active_tile.tile_options.map((tiles) => {

                if (tiles.if_json) {
                        this.if_condition = Object.assign(this.if_condition, { [tiles.json.tag_name]: false});
                        if (tiles.syntax === "msgbox") {
                            if (tiles.json.message_type === "markdown") {
                                var str1 = tiles.json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                                .replace("{{user_username}}", this.user_username)
                                .replace("{{user_domain}}", window.location.origin)
                                .replace("{{tap_version}}", this.appVersion)
                                .replace("{{location}}",  this.ip_location)
                                .replace("{{user_book}}", this.$store.getters.selected_book)
                                .replace("{{user_page}}", this.$store.getters.selected_page)
                                .replace("{{user_tile}}", tiles.title)
                                .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                                .replace("{{time_now}}", this.getClockTime())
        
                                str1 = str1+"";
                                
                                // var pre = str.substring(0, str.indexOf('[code]'));
        
                                // //replace < within code-tags by &lt;
                                // pre += str.substring(str.indexOf('[code]'), str.indexOf('[/code]'))
                                //         .replace(new RegExp('<', 'g'),'&lt;');
        
                                // //concatenate the remaining text
                                // pre += str.substring(str.indexOf('[/code]'), str.length);
        
                                // pre = pre.replace('[code]', '<pre>');
                                // pre = pre.replace('[/code]', '</pre>');

                                // str = "<h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+tiles.json.title+"</h2><br>"+tiles.json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                                // .replace("{{user_username}}", this.user_username)
                                // .replace("{{user_domain}}", window.location.origin)
                                // .replace("{{tap_version}}", this.appVersion)
                                // .replace("{{location}}", this.ip_location)
                                // .replace("{{user_book}}", this.$store.getters.selected_book)
                                // .replace("{{user_page}}", this.$store.getters.selected_page)
                                // .replace("{{user_tile}}", tiles.title)
                                // .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                                // .replace("{{time_now}}", today.getHours() + ":" + today.getMinutes());

                                var sanitized_title = "";
                                /* eslint-disable */
                                sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >

                                var fullsizeImage = str1.replace(/alt="" width="320"/g, 'alt="" width="100%"');
                                str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2>"+md.render(fullsizeImage);
        
                            } else if (tiles.json.message_type === "URL") {
                                str = "";

                                url = tiles.json.url;
        
                                reg = new RegExp(/\{\{(.*?)\}\}/g);
                                matches = tiles.json.url.match(reg);
                                found;
                                url;
                                if (matches) {
                                        found = reg.exec(tiles.json.url);
                                        if (this.dynamic_mergecodes[found[1]]) {
                                            url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                                        }
                                }

                                var sanitized_title = "";
                                var sanitized_msg_url = "";
                                /* eslint-disable */
                                sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >

                                sanitized_msg_url = this.message_url[tiles.json.tag_name].replace(/\n/g, "<br />");

                                if (url.includes('uberlist')) {
                                    str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><p>"+sanitized_msg_url+"</p>";
                                } else {
                                    str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><iframe src='"+sanitized_msg_url+"' style='width: 100% !important; height: 300px !important;' title='description' ></iframe>";
                                }
                                
                                
                            } else {


                                var sanitized_title = "";
                                /* eslint-disable */
                                sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                                
                                
                                str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><br>"+tiles.json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                                .replace("{{user_username}}", this.user_username)
                                .replace("{{user_domain}}", window.location.origin)
                                .replace("{{tap_version}}", this.appVersion)
                                .replace("{{location}}", this.ip_location)
                                .replace("{{user_book}}", this.$store.getters.selected_book)
                                .replace("{{user_page}}", this.$store.getters.selected_page)
                                .replace("{{user_tile}}", tiles.title)
                                .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                                .replace("{{time_now}}", today.getHours() + ":" + today.getMinutes());
                            
                                var fullsizeImage = str.replace(/alt="" width="320"/g, 'alt="" width="100%"');
                                
                                str = fullsizeImage;
                            }
                        
                        }
        
                        else if (tiles.syntax === "rocketchat") {
                        
                            str = "";
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded',
                                                                                                rocketchat_url: tiles.json.url});

                            if (!this.url_get_options.includes(tiles.json.sort+1)) {
                                this.url_get_options.push(tiles.json.sort+1);
                            }
        
                        }
        
                        else if (tiles.syntax === "urlget") {
                        
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: tiles.json.url});
                            if (!this.url_get_options.includes(tiles.json.sort+1)) {
                                this.url_get_options.push(tiles.json.sort+1);
                            }
                            str = "";
                        }
        
                        else if (tiles.syntax === 'location') {
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: tiles.json.description});
                            


                            str = "";
                            
                        }
        
                        else if (tiles.syntax === "open") {
                        
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                            str = "";
        
                            url = tiles.json.url;
        
                            var reg = new RegExp(/\{\{(.*?)\}\}/g);
                            var matches = tiles.json.url.match(reg);
                            var found;
                            var url;
                            if (matches) {
                                    found = reg.exec(tiles.json.url);
                                    if (this.dynamic_mergecodes[found[1]]) {
                                        url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                                        this.dynamic_mergecodes[tiles.json.tag_name] = url;
                                    }
                            } else {
                                this.dynamic_mergecodes[tiles.json.tag_name] = url;
                            }
                        
                            str = "<a data-option='open' href='"+this.dynamic_mergecodes[tiles.json.tag_name]
                            +"' target='_blank' class='' style='text-decoration:none;color: #0089cf;'>"
                            +"<img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAAAjFJREFUWEftmE1SwjAUgF9Y6FKPgCeQegE4AjcQTyBsRFbKCsoGb6A3EE8AXMBwA/AGuNQF8b3Eig6lyUvbzDhDZuh0mPfz9SXvpxUQYg1kFQQ84q/BcLeGDXQEQ8FfdCinTLjE1zoMYCyV79OFApwhYN0HMgygPoNqAUKccCHDABLVSNZgo2ZcyHCAnpB/AUevdVDCXgoEvMBNtOBul5YfyBZUsOQ4LgNI4VdaqeaoB1ijrqAXPTnLb/1M8fbUVU/AWJ7CJyw5Stq4ghXcRmeujr6DwIIj2wJiSVG4dHb0I6jeoHtRddIzO8SGM4BDucSrm6PfNK5bnAWn1Due+TaWoId92U0RTKvy/czICJg4JYkNroIJScmWUYLSAbtR/vLjCpdEIh1yXg4gFy6BpI5TAcoJaotzrBSt4gF94facqWIBC4ZLysxukvicwRLgigMsCa4YwBLh8gOWDJcPMACcP2AgOD9Amn4+QKb2b+qtSftymiLsQvw6GMs2mh3vmC4Bzi+CaYAcOJqoBdzpB1TQtw29/AjqLdYvP+cmijgXCtF0mm4GsoG9lubC7RIQZenyAcm0mcJb2ssRNvdOtLafJpSI5T1eTfS2qw/diP5PXX6ATjQpQgdA38gleocIHiK4G4F/msV5t5Knb62DM7Tn9XGRx7G3Els7SRNVnwtxxjcyxy7SyFIzL+hDiZ8e4JpvP48G9vANflnoRSs7IEmYRk49seTtRjAlJnCMvhx6+Bcecl2AxOvnJgAAAABJRU5ErkJggg==' class='h-[20px] inline'><small> Open in a new tab</small></a>";
        
                        }
        
                        else if (tiles.syntax === "inputbox") {
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                            reg = new RegExp(/\{\{(.*?)\}\}/g);
                            matches = tiles.json.default.match(reg);
                            found;
                            if (matches) {
                                // console.log(tiles.json.tag_name+"test1");
                                    for (var i = 0; i < matches.length; i++) {
                                    found = reg.exec(tiles.json.default);
                                    
                                        if (this.$data[found[1]]) {
                                            this.dynamic_mergecodes[tiles.json.tag_name] = this.$data[found[1]];
                                        }
                                    }
                            } else {
                                // console.log(tiles.json.tag_name);
                                Object.assign(this.$data, { [tiles.json.tag_name]: tiles.json.default});
                            
                                        if (this.$data[tiles.json.tag_name]) {
                                            this.dynamic_mergecodes[tiles.json.tag_name] = this.$data[tiles.json.tag_name];
                                        }
                            }
                            
                            var sanitized_title = "";
                            var sanitized_details = "";
                            /* eslint-disable */
                            sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >

                            /* eslint-disable */
                            sanitized_details = tiles.json.details.replace(/\</g,"&lt;")   //for <
                            sanitized_details = sanitized_details.replace(/\>/g,"&gt;")   //for >

                            var input_type = 'text';
                            var input_onkeydown = true;

                            if (tiles.json.input_type == 'text') {
                                input_type = 'text';
                                input_onkeydown = true;
                            } else if (tiles.json.input_type == 'date') { 
                                input_type = 'date';
                                input_onkeydown = false;
                            } else if (tiles.json.input_type == 'time') { 
                                input_type = 'time';
                                input_onkeydown = false;
                            } else if (tiles.json.input_type == 'datetime') { 
                                input_type = 'datetime-local';
                                input_onkeydown = false;
                            }
                            

                            if (
                                tiles.json.input_type == 'date' ||
                                tiles.json.input_type == 'time' ||
                                tiles.json.input_type == 'datetime'
                            ) {
                                this.validation[tiles.json.tag_name] = {
                                    "validation_value":'',
                                    "condition":'datetime',
                                    "message":'This field is required.',
                                    "condition_met":false
                                }

                                str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    tiles.json.placeholder+"' name='"+
                                    tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                            
                            } else {
                                if (tiles.json.validation != 'no_validation' && tiles.json.validation != "") {
                                    this.validation[tiles.json.tag_name] = {
                                                                            "validation_value":tiles.json.validation_value,
                                                                            "condition":tiles.json.validation,
                                                                            "message":tiles.json.validation_message,
                                                                            "condition_met":false
                                                                            }
                                    if (tiles.json.validation_message == "") {
                                        var valid_message = "This field is required.";
                                    } else {
                                        valid_message = tiles.json.validation_message;
                                    }

                                    str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>"+valid_message+"</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    tiles.json.placeholder+"' name='"+
                                    tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                                } else if (tiles.json.validation === "" || tiles.json.validation === null) {
                                    str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                                    sanitized_title+"</label><label>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    tiles.json.placeholder+"' name='"+
                                    tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                                } else {
                                    str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                                    sanitized_title+"</label><label>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    tiles.json.placeholder+"' name='"+
                                    tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                                }
                            }


                           
                        }
        
                        else if (tiles.syntax === "selectbox") {

                            if (tiles.json.validation != 'no_validation') {

                                var sanitized_title = "";
                                var sanitized_desc = "";
                                /* eslint-disable */
                                sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                                sanitized_desc = tiles.json.description.replace(/\</g,"&lt;")   //for <
                                sanitized_desc = sanitized_desc.replace(/\>/g,"&gt;")   //for >

                                if (tiles.json.url) {
                                    if (tiles.json.url.includes('badgepack')) {
                                       this.validation[tiles.json.tag_name] = {
                                           "validation_value":'',
                                           "condition":'badgepack',
                                           "message":'Complete the task.',
                                           "condition_met":false
                                           }
                                           

                                       str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                       sanitized_title+"</label>"
                                       +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>Complete the task.</small></label>"
                                       +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                       sanitized_desc+"</label>";
                                    } else {

                                        this.validation[tiles.json.tag_name] = {
                                            "validation_value":'',
                                            "condition":'notnull',
                                            "message":'This field is required.',
                                            "condition_met":false
                                        }


                                        str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                        sanitized_title+"</label>"
                                        +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                        +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                        sanitized_desc+"</label>";     
                                     }
                                } else {
                                    this.validation[tiles.json.tag_name] = {
                                        "validation_value":'',
                                        "condition":'notnull',
                                        "message":'This field is required.',
                                        "condition_met":false
                                        }

                                    str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_desc+"</label>";
                                }

                                // this.validation[tiles.json.tag_name] = {
                                //                                         "validation_value":'',
                                //                                         "condition":'notnull',
                                //                                         "message":'This field is required.',
                                //                                         "condition_met":false
                                //                                         }

                                // str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                // tiles.json.title+"</label>"
                                // +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                // +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                // tiles.json.description+"</label>";
                            } else {
                                var sanitized_title = "";
                                var sanitized_desc = "";
                                /* eslint-disable */
                                sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                                sanitized_desc = tiles.json.description.replace(/\</g,"&lt;")   //for <
                                sanitized_desc = sanitized_desc.replace(/\>/g,"&gt;")   //for >

                                str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                                sanitized_title+"</label><label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                sanitized_desc+"</label>";
                            }

                            if (tiles.json.url) { 
                                    if (tiles.json.url.includes('badgepack')) {
                                        str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                        content = [];
                                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                                    
                                            tiles.json.option_label.map((options, index) => {
                                                // if (tiles.json['url_return'] === 'value') {
                                                //         var hasValue = tiles.json.option_value[index];
                                                // } else if (tiles.json['url_return'] === 'name') {
                                                        var hasValue = options;
                                                // }

                                                index = this.bp_integration.map(badge => {
                                                    return badge.title; 
                                                }).indexOf(options);

                                                var sanitized_options = "";
                                                var sanitized_value = "";
                                                /* eslint-disable */
                                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                                if (this.bp_integration[index]) {
                                                    if (this.bp_integration[index].is_checked == 'yes') {
                                                        content[index] = "<div class='form-check '>"+
                                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='button_bp' value='"+sanitized_value+"'/>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' style='background-color: green; color: white; border: 1px solid white;' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                    } else {
                                                        content[index] = "<div class='form-check '>"+
                                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='button_bp' value='"+sanitized_value+"'/>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' style='color: gray; border: 1px solid gray;' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                    }
                                                } else {
                                                    content[index] = "<div class='form-check '>"+
                                                    "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='button_bp' value='"+sanitized_value+"'/>"+
                                                    "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                    "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                    "</label>"+
                                                    "</div>";
                                                }
                                                
                                            
                                            });
        
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                    } else if (tiles.json.url.includes('uberlist')) { // IF SELECTBOX -> URL -> UBERLIST
                                        if (tiles.json.input_type == "radio") {
                                            str_concat_prefix = "<br><div class=''>"+"<div class='flex flex-wrap '>";
                                            content = [];
                                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
            
                                            if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                                tiles.json.option_label.map((options, index) => {
                                                    //if (tiles.json['url_return'] === 'value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                    // } else if (tiles.json['url_return'] === 'name') {
                                                    //         hasValue = options;
                                            
                                                    // }

                                                    var sanitized_options = "";
                                                    var sanitized_value = "";
                                                    /* eslint-disable */
                                                    sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                    sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                    sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                    sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                    
                                                    content[index] = "<div class='form-check'>"+
                                                    "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                    "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                    "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                    sanitized_options+"</span>"+
                                                    "</label>"+
                                                    "</div>";
            
                                                    
                                                });
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                                    
                                            } else {
                                                if (tiles.json.option_label.length > 0) {
                                                    tiles.json.option_label.map((options, index) => {
                                                        if (tiles.json['option-type'] === 'name_value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                        } else if (tiles.json['option-type'] === 'name-only') {
                                                            hasValue = options;
                                                        } else {
                                                            hasValue = options;
                                                        }

                                                        var sanitized_options = "";
                                                        var sanitized_value = "";
                                                        /* eslint-disable */
                                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                        
                                                        content[index] = "<div class='form-check'>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                        "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                        sanitized_options+"</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                        });
            
                                                        if (tiles.json.allow_other_option === "yes") {
                                                            custom_index = tiles.json.option_label.length;
                                                            // console.log("OTHER:", custom_index);
                                                            content[custom_index] = "<div class='form-check'>"+
                                                            "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                            "<span id='otherLabel"+tiles.json.tag_name+"'>"+
                                                            "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"'data-inputtype='otherBtn' value='Other'/> "+
                                                            "&emsp;Other"+
                                                            "</span>"+
                                                            "</label>"+
                                                            "</div>";
                                                        }
                                                        str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                                    } else {
                                                        str_concat_prefix = "<div class='flex'>"+"<div>";
                                                        str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                                    }
                                            } ///OPTION TYPE CLOSE
                                        }
                    
                                        if (tiles.json.input_type == "checkbox") {
                                            str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap '>";
                                            content = [];
                                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
            
                                            if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                                tiles.json.option_label.map((options, index) => {
                                                    // if (tiles.json['url_return'] === 'value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                    // } else if (tiles.json['url_return'] === 'name') {
                                                    //         hasValue = options;
                                            
                                                    // }

                                                    var sanitized_options = "";
                                                    var sanitized_value = "";
                                                    /* eslint-disable */
                                                    sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                    sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                    sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                    sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                    
                                                    content[index] = "<div class='form-check'>"+
                                                    "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                    "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                    "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                    sanitized_options+"</span>"+
                                                    "</label>"+
                                                    "</div>";
            
                                                });
            
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                                    
                                            } else {
                                                if (tiles.json.option_label.length > 0) {
                                                    tiles.json.option_label.map((options, index) => {
                                                        if (tiles.json['option-type'] === 'name_value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                        } else if (tiles.json['option-type'] === 'name-only') {
                                                            hasValue = options;
                            
                                                        } else {
                                                            hasValue = options;
                                                        }

                                                        var sanitized_options = "";
                                                        var sanitized_value = "";
                                                        /* eslint-disable */
                                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                                        
                                                        content[index] = "<div class='form-check'>"+
                                                        "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                        "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                        sanitized_options+
                                                        "</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                        });
            
                                                        
                                                        // if (tiles.json.allow_other_option === "yes") {
                                                        //      custom_index = tiles.json.option_label.length;
                                                        //     console.log("OTHER:", custom_index);
                                                        //     content[custom_index] = "<div class='form-check'>"+
                                                        //     "<label class='labelclass-"+tiles.json.tag_name+custom_index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                        //     "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                                        //         "<span id='otherLabel"+tiles.json.tag_name+"'>&emsp;Other</span>"+
                                                        //         "</label>"+
                                                        //         "</div>";
                                                        
                                                        // }
            
            
                                                        str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                                    } else {
                                                        str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                                        str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                                    }
                                            } ///OPTION TYPE CLOSE
                                        }
                    
                                        if ((tiles.json.input_type == "button" || tiles.json.input_type == "name-only")) {
                                            str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                            content = [];
                                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                                            if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                                tiles.json.option_label.map((options, index) => {
                                                    // if (tiles.json['url_return'] === 'value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                    // } else if (tiles.json['url_return'] === 'name') {
                                                    //         hasValue = options;
                                            
                                                    // }

                                                    var sanitized_options = "";
                                                    var sanitized_value = "";
                                                    /* eslint-disable */
                                                    sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                    sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                    sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                    sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                
                                                    // hasValue = hasValue.replaceAll("'", "");
                                                    content[index] = "<div class='form-check '>"+
                                                    "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                                    "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                    "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                    "</label>"+
                                                    "</div>";
            
                                                });

                                                if (tiles.json.allow_other_option === "yes") {
                                                    custom_index = tiles.json.option_label.length;
                                                    // console.log("OTHER:", custom_index);
                                                    content[custom_index] = "<div class='form-check'>"+
                                                    "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value='Other'/>"+
                                                    "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                    "<span><span id='otherLabel"+tiles.json.tag_name+"'>Other</span></span>"+
                                                    "</label>"+
                                                    "</div>";
                                                }
            
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                                    
                                            } else {
                                                if (tiles.json.option_label.length > 0) {
                                                    tiles.json.option_label.map((options, index) => {
                                                        if (tiles.json['option-type'] === 'name_value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                        } else if (tiles.json['option-type'] === 'name-only') {
                                                            hasValue = options;
                                                        } else {
                                                            hasValue = options;
                                                        }

                                                        var sanitized_options = "";
                                                        var sanitized_value = "";
                                                        /* eslint-disable */
                                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                        
                                                        // hasValue = hasValue.replaceAll("'", "");
                                                        content[index] = "<div class='form-check'>"+
                                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                       "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                    });
            
                                                    if (tiles.json.allow_other_option === "yes") {
                                                        custom_index = tiles.json.option_label.length;
                                                        // console.log("OTHER:", custom_index);
                                                        content[custom_index] = "<div class='form-check'>"+
                                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value='Other'/>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                        "<span><span id='otherLabel"+tiles.json.tag_name+"'>Other</span></span>"+
                                                        "</label>"+
                                                        "</div>";
                                                    }
            
                                                    str_concat_suffix = "</div>"+"</div>"
                                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix; 
                                                } else {
                                                    str_concat_prefix = "<div class='flex'>"+"<div>";
                                                    str_concat_suffix = "</div>"+"</div>"
                                                    this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                                }
                                            } ///OPTION TYPE CLOSE
                                        } 
                                    } else {
                                        if (tiles.json.input_type == "radio") {
                                            var str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap'>";
                                            var content = [];
                                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
        
                                            if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                                tiles.json.option_label.map((options, index) => {
                                                    if (tiles.json['url_return'] === 'value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                    } else if (tiles.json['url_return'] === 'name') {
                                                            hasValue = options;
                                                    }

                                                    var sanitized_options = "";
                                                    var sanitized_value = "";
                                                    /* eslint-disable */
                                                    sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                    sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                    sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                    sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >


                                                    content[index] = "<div class='form-check'>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                        "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                        sanitized_options+
                                                        "</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                });
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;  
                                            } else {
                                                if (tiles.json.option_label.length > 0) {
                                                    tiles.json.option_label.map((options, index) => {
                                                        if (tiles.json['option-type'] === 'name_value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                        } else if (tiles.json['option-type'] === 'name-only') {
                                                            hasValue = options;
                                                        } else {
                                                            hasValue = options;
                                                        }

                                                        var sanitized_options = "";
                                                        var sanitized_value = "";
                                                        /* eslint-disable */
                                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                                        content[index] = "<div class='form-check'>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                        "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                        sanitized_options+
                                                        "</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                        });
        
                                                        if (tiles.json.allow_other_option === "yes") {
                                                            custom_index = tiles.json.option_label.length;
                                                            // console.log("OTHER:", custom_index);
                                                            content[custom_index] = "<div class='form-check'>"+
                                                            "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                            "<span id='otherLabel"+tiles.json.tag_name+"'>"
                                                            "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"'data-inputtype='otherBtn' value=''/> "+
                                                            +"&emsp;Other"
                                                            +"</span>"+
                                                            "</label>"+
                                                            "</div>";
                                                        }
                                                        var str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                                    } else {
                                                        str_concat_prefix = "<div class='flex'>"+"<div>";
                                                        str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                                    }
                                            } ///OPTION TYPE CLOSE
                                        }
    
                                        if (tiles.json.input_type == "checkbox") {
                                            str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap '>";
                                            content = [];
                                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
        
                                            if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                                tiles.json.option_label.map((options, index) => {
                                                    if (tiles.json['url_return'] === 'value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                    } else if (tiles.json['url_return'] === 'name') {
                                                            hasValue = options;
                                            
                                                    }

                                                    var sanitized_options = "";
                                                    var sanitized_value = "";
                                                    /* eslint-disable */
                                                    sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                    sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                    sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                    sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                                    content[index] = "<div class='form-check'>"+
                                                    "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                    "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                    "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                    sanitized_options+
                                                    "</span>"+
                                                    "</label>"+
                                                    "</div>";
        
                                                });
        
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                                    
                                            } else {
                                                if (tiles.json.option_label.length > 0) {
                                                    tiles.json.option_label.map((options, index) => {
        
                                                        
                                                            if (tiles.json['option-type'] === 'name_value') {
                                                                var hasValue = tiles.json.option_value[index];
                                                            } else if (tiles.json['option-type'] === 'name-only') {
                                                                hasValue = options;
                                                            } else {
                                                                hasValue = options;
                                                            }


                                                        var sanitized_options = "";
                                                        var sanitized_value = "";
                                                        /* eslint-disable */
                                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                      
                                                        content[index] = "<div class='form-check'>"+
                                                        "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                        "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                        sanitized_options+
                                                        "</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                        });
                                                        // if (tiles.json.allow_other_option === "yes") {
                                                        //      custom_index = tiles.json.option_label.length;
                                                        //     console.log("OTHER:", custom_index);
                                                        //     content[custom_index] = "<div class='form-check'>"+
                                                        //     "<label class='labelclass-"+tiles.json.tag_name+custom_index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                        //     "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                                        //         "<span id='otherLabel"+tiles.json.tag_name+"'>&emsp;Other</span>"+
                                                        //         "</label>"+
                                                        //         "</div>";
                                                        // }
                                                        str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                                    } else {
                                                        str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                                        str_concat_suffix = "</div>"+"</div>"
                                                        this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                                    }
                                            } ///OPTION TYPE CLOSE
                                        }
                    
                                        if ((tiles.json.input_type == "button" || tiles.json.input_type == "name-only")) {
                                            str_concat_prefix = "<div class='flex'>"+"<div clsss='flex flex-wrap overflow-hidden'>";
                                            content = [];
                                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                                            if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                                tiles.json.option_label.map((options, index) => {
                                                    if (tiles.json['url_return'] === 'value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                    } else if (tiles.json['url_return'] === 'name') {
                                                            hasValue = options;
                                            
                                                    }

                                                    var sanitized_options = "";
                                                    var sanitized_value = "";
                                                    /* eslint-disable */
                                                    sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                    sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                    sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                    sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                                    content[index] = "<div class='form-check'>"+
                                                    "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                                    "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                   "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                    "</label>"+
                                                    "</div>";
                                                });
        
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                                    
                                            } else {
                                                if (tiles.json.option_label.length > 0) {
                                                    tiles.json.option_label.map((options, index) => {
                                                        if (tiles.json['option-type'] === 'name_value') {
                                                            var hasValue = tiles.json.option_value[index];
                                                        } else if (tiles.json['option-type'] === 'name-only') {
                                                            hasValue = options;
                                                        } else {
                                                            hasValue = options;
                                                        }

                                                        var sanitized_options = "";
                                                        var sanitized_value = "";
                                                        /* eslint-disable */
                                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                                        content[index] = "<div class='form-check'>"+
                                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                       "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                        "</label>"+
                                                        "</div>";
                                                    });
        
                                                    if (tiles.json.allow_other_option === "yes") {
                                                        var custom_index = tiles.json.option_label.length;
                                                        // console.log("OTHER:", custom_index);
                                                        content[custom_index] = "<div class='form-check'>"+
                                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                                        "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                        "<span><span id='otherLabel"+tiles.json.tag_name+"'>Other</span></span>"+
                                                        "</label>"+
                                                        "</div>";
                                                    }
        
                                                    str_concat_suffix = "</div>"+"</div>"
                                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix; 
                                                } else {
                                                    str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                                    str_concat_suffix = "</div>"+"</div>"
                                                    this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                                }
                                            } ///OPTION TYPE CLOSE
                                        } 
                                    }
                            } else {

                            if (tiles.json.input_type == "radio") {
                                str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap'>";
                                content = [];
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});

                                if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                    tiles.json.option_label.map((options, index) => {
                                        if (tiles.json['url_return'] === 'value') {
                                                var hasValue = tiles.json.option_value[index];
                                        } else if (tiles.json['url_return'] === 'name') {
                                                hasValue = options;
                                        }

                                        var sanitized_options = "";
                                        var sanitized_value = "";
                                        /* eslint-disable */
                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                        content[index] = "<div class='form-check'>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                            "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                            sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
                                    });
                                    str_concat_suffix = "</div>"+"</div>"
                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;  
                                } else {
                                    if (tiles.json.option_label.length > 0) {
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['option-type'] === 'name_value') {
                                                var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['option-type'] === 'name-only') {
                                                hasValue = options;
                                            } else {
                                                hasValue = options;
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                            content[index] = "<div class='form-check'>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                            "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                            sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
                                            });

                                            if (tiles.json.allow_other_option === "yes") {
                                                custom_index = tiles.json.option_label.length;
                                                // console.log("OTHER:", custom_index);
                                                content[custom_index] = "<div class='form-check'>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                "<span id='otherLabel"+tiles.json.tag_name+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"'data-inputtype='otherBtn' value=''/> "+
                                                "&emsp;Other"+
                                                "</span>"+
                                                "</label>"+
                                                "</div>";
                                            }
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                        } else {
                                            str_concat_prefix = "<div class='flex'>"+"<div>";
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                        }
                                } ///OPTION TYPE CLOSE
                            }

                            if (tiles.json.input_type == "checkbox") {
                                str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap '>";
                                content = [];
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});

                                if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                    tiles.json.option_label.map((options, index) => {
                                        if (tiles.json['url_return'] === 'value') {
                                                var hasValue = tiles.json.option_value[index];
                                        } else if (tiles.json['url_return'] === 'name') {
                                                hasValue = options;
                                
                                        }

                                        var sanitized_options = "";
                                        var sanitized_value = "";
                                        /* eslint-disable */
                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >


                                        content[index] = "<div class='form-check'>"+
                                        "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                        "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                        sanitized_options+
                                        "</span>"+
                                        "</label>"+
                                        "</div>";

                                    });

                                    str_concat_suffix = "</div>"+"</div>"
                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                        
                                } else {
                                    if (tiles.json.option_label.length > 0) {
                                        tiles.json.option_label.map((options, index) => {

                                            
                                                if (tiles.json['option-type'] === 'name_value') {
                                                    var hasValue = tiles.json.option_value[index];
                                                } else if (tiles.json['option-type'] === 'name-only') {
                                                    hasValue = options;
                                                } else {
                                                    hasValue = options;
                                                }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                          
                                            content[index] = "<div class='form-check'>"+
                                            "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                            "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                            sanitized_options+
                                            "</span>"+
                                            "</label>"+
                                            "</div>";
                                            });
                                            // if (tiles.json.allow_other_option === "yes") {
                                            //      custom_index = tiles.json.option_label.length;
                                            //     console.log("OTHER:", custom_index);
                                            //     content[custom_index] = "<div class='form-check'>"+
                                            //     "<label class='labelclass-"+tiles.json.tag_name+custom_index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                            //     "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                            //         "<span id='otherLabel"+tiles.json.tag_name+"'>&emsp;Other</span>"+
                                            //         "</label>"+
                                            //         "</div>";
                                            // }
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                        } else {
                                            str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                        }
                                } ///OPTION TYPE CLOSE
                            }
        
                            if ((tiles.json.input_type == "button" || tiles.json.input_type == "name-only")) {
                                str_concat_prefix = "<div class='flex'>"+"<div clsss='flex flex-wrap overflow-hidden'>";
                                content = [];
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                                if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                    tiles.json.option_label.map((options, index) => {
                                        if (tiles.json['url_return'] === 'value') {
                                                var hasValue = tiles.json.option_value[index];
                                        } else if (tiles.json['url_return'] === 'name') {
                                                hasValue = options;
                                        }


                                        var sanitized_options = "";
                                        var sanitized_value = "";
                                        /* eslint-disable */
                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                        content[index] = "<div class='form-check'>"+
                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                        "</label>"+
                                        "</div>";
                                    });

                                    str_concat_suffix = "</div>"+"</div>"
                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                        
                                } else {
                                    if (tiles.json.option_label.length > 0) {
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['option-type'] === 'name_value') {
                                                var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['option-type'] === 'name-only') {
                                                hasValue = options;
                
                                            } else {
                                                hasValue = options;
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >


                                            content[index] = "<div class='form-check'>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
                                        });

                                        if (tiles.json.allow_other_option === "yes") {
                                            custom_index = tiles.json.option_label.length;
                                            // console.log("OTHER:", custom_index);
                                            content[custom_index] = "<div class='form-check'>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                            "<span><span id='otherLabel"+tiles.json.tag_name+"'>Other</span></span>"+
                                            "</label>"+
                                            "</div>";
                                        }

                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix; 
                                    } else {
                                        str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                    }
                                } ///OPTION TYPE CLOSE
                            }
                            str = str+this.str_concat;
                        }
                    }

                    str = "<div id='ifCond"+tiles.json.tag_name+"' class='hidden' >"+str+"</div>";
                } else {
                    if (tiles.syntax === "msgbox") {
                        if (tiles.json.message_type === "markdown") {
                            str1 = tiles.json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                            .replace("{{user_username}}", this.user_username)
                            .replace("{{user_domain}}", window.location.origin)
                            .replace("{{tap_version}}", this.appVersion)
                            .replace("{{location}}", this.ip_location)
                            .replace("{{user_book}}", this.$store.getters.selected_book)
                            .replace("{{user_page}}", this.$store.getters.selected_page)
                            .replace("{{user_tile}}", tiles.title)
                            .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                            .replace("{{time_now}}", today.getHours() + ":" + today.getMinutes());
    
                            str1 = str1+"";
                            
                            // pre = str.substring(0, str.indexOf('[code]'));
    
                            // //replace < within code-tags by &lt;
                            // pre += str.substring(str.indexOf('[code]'), str.indexOf('[/code]'))
                            //         .replace(new RegExp('<', 'g'),'&lt;');
    
                            // //concatenate the remaining text
                            // pre += str.substring(str.indexOf('[/code]'), str.length);
    
                            // pre = pre.replace('[code]', '<pre>');
                            // pre = pre.replace('[/code]', '</pre>');

                            // str = "<h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+tiles.json.title+"</h2><br>"+tiles.json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                            // .replace("{{user_username}}", this.user_username)
                            // .replace("{{user_domain}}", window.location.origin)
                            // .replace("{{tap_version}}", this.appVersion)
                            // .replace("{{location}}", this.ip_location)
                            // .replace("{{user_book}}", this.$store.getters.selected_book)
                            // .replace("{{user_page}}", this.$store.getters.selected_page)
                            // .replace("{{user_tile}}", tiles.title)
                            // .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                            // .replace("{{time_now}}", today.getHours() + ":" + today.getMinutes());

                            var sanitized_title = "";
                            /* eslint-disable */
                            sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >

                            var fullsizeImage = str1.replace(/alt="" width="320"/g, 'alt="" width="100%"');
                            
                            str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2>"+md.render(fullsizeImage);
    
                        } else if (tiles.json.message_type === "URL") {
                            str = "";

                            url = tiles.json.url;
        
                            reg = new RegExp(/\{\{(.*?)\}\}/g);
                            matches = tiles.json.url.match(reg);
                            found;
                            url;
                            if (matches) {
                                    found = reg.exec(tiles.json.url);
                                    if (this.dynamic_mergecodes[found[1]]) {
                                        url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                                    }
                            }

                            var sanitized_title = "";
                            var sanitized_msg_url = "";
                            /* eslint-disable */
                            sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                            
                            sanitized_msg_url = this.message_url[tiles.json.tag_name].replace(/\n/g, "<br />");

                            if (url.includes('uberlist')) {
                                str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><p>"+sanitized_msg_url+"</p>";
                            } else {
                                if (matches) {
                                    str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><urlmsgbox_"+found[1]+"><iframe src='"+sanitized_msg_url+"' style='width: 100% !important; height: 300px !important;' title='description' ></iframe></urlmsgbox_"+found[1]+">";
                                } else { 
                                    str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><iframe src='"+sanitized_msg_url+"' style='width: 100% !important; height: 300px !important;' title='description' ></iframe>";
                                
                                }
                                 }
                        } else {

                            var sanitized_title = "";
                                /* eslint-disable */
                            sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                            str = "<br><h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><br>"+tiles.json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                            .replace("{{user_username}}", this.user_username)
                            .replace("{{user_domain}}", window.location.origin)
                            .replace("{{tap_version}}", this.appVersion)
                            .replace("{{location}}", this.ip_location)
                            .replace("{{user_book}}", this.$store.getters.selected_book)
                            .replace("{{user_page}}", this.$store.getters.selected_page)
                            .replace("{{user_tile}}", tiles.title)
                            .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                            .replace("{{time_now}}", today.getHours() + ":" + today.getMinutes());
                            
                            var fullsizeImage = str.replace(/alt="" width="320"/g, 'alt="" width="100%"');
                            str = fullsizeImage;
                        }
                    
                    }

                    else if (tiles.syntax === "file") {


                        var sanitized_title = "";
                        var sanitized_details = "";
                        /* eslint-disable */
                        sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                        sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                        
                        
                        /* eslint-disable */
                        sanitized_details = tiles.json.description.replace(/\</g,"&lt;")   //for <
                        sanitized_details = sanitized_details.replace(/\>/g,"&gt;")   //for >
                    
                        str = "";
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                        this.file_uploads.push({
                            sort: tiles.sort,
                            tag_name: tiles.json.tag_name,
                            value: ''
                         });
                        

                        str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                sanitized_title+"</label>"
                                +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                sanitized_details+"</label>"
                                +"<div>"
                                    +"<div class='drop-zone-idle dropzone' name='"+tiles.json.tag_name+"'>"
                                        +"<input type='file' id='"+tiles.json.tag_name+"' name='"+tiles.json.tag_name+"' size='60'/>"
                                        +"<center><p style='width: 20%;'>or Drag and Drop a file</p></center>"
                                    +"</div>"
                                +"</div>";
                    }
                    

                    else if (tiles.syntax === "video_media") {


                        var sanitized_title = "";
                        var sanitized_details = "";
                        /* eslint-disable */
                        sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                        sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                        
                        
                        /* eslint-disable */
                        sanitized_details = tiles.json.description.replace(/\</g,"&lt;")   //for <
                        sanitized_details = sanitized_details.replace(/\>/g,"&gt;")   //for >
                    
                        str = "";
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                        
                        
                        if (tiles.json.url.startsWith('https://')) {
                            var vidmedia = "<center><video style='height: 480px;' controls controlsList='nodownload'>"
                            +"<source src='"+tiles.json.url+"'>"
                            +"Your browser does not support the HTML5 video tag. Please update your browser or try a different one."
                            +"</video></center>";  
                        } else {
                            vidmedia = "<center><p style='background-color: black; color: white; width: 60%; height: 100px;'>Failed to load the video because the provided URL is not secure.</p></center>";  
                        }

                        str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                sanitized_title+"</label>"
                                +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                sanitized_details+"</label>"
                                +"<div>"
                                    +vidmedia
                                +"</div>";
                    }
    
    
                    else if (tiles.syntax === "rocketchat") {
                    
                        str = "";
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded',
                                                                                            rocketchat_url: tiles.json.url});
                        
                        if (!this.url_get_options.includes(tiles.json.sort+1)) {
                            this.url_get_options.push(tiles.json.sort+1);
                        }
                    }
    
                    else if (tiles.syntax === "urlget") {
                    
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: tiles.json.url});
                        if (!this.url_get_options.includes(tiles.json.sort+1)) {
                            this.url_get_options.push(tiles.json.sort+1);
                        }
                       
                        str = "";
                    }
    
                    else if (tiles.syntax === 'location') {
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                        str = "";
                        
                    }
    
                    else if (tiles.syntax === "open") {
                    
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                        str = "";
    
                        url = tiles.json.url;
    
                        reg = new RegExp(/\{\{(.*?)\}\}/g);
                        matches = tiles.json.url.match(reg);
                        found;
                        url;
                        if (matches) {
                                found = reg.exec(tiles.json.url);
                                if (this.dynamic_mergecodes[found[1]]) {
                                    url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                                    this.dynamic_mergecodes[tiles.json.tag_name] = url;
                                }
                        } else {
                            this.dynamic_mergecodes[tiles.json.tag_name] = url;
                        }
                    
                        str = "<br><a data-option='open' href='"+this.dynamic_mergecodes[tiles.json.tag_name]
                        +"' target='_blank' class='' style='text-decoration:none;color: #0089cf;'>"
                        +"<img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAAAjFJREFUWEftmE1SwjAUgF9Y6FKPgCeQegE4AjcQTyBsRFbKCsoGb6A3EE8AXMBwA/AGuNQF8b3Eig6lyUvbzDhDZuh0mPfz9SXvpxUQYg1kFQQ84q/BcLeGDXQEQ8FfdCinTLjE1zoMYCyV79OFApwhYN0HMgygPoNqAUKccCHDABLVSNZgo2ZcyHCAnpB/AUevdVDCXgoEvMBNtOBul5YfyBZUsOQ4LgNI4VdaqeaoB1ijrqAXPTnLb/1M8fbUVU/AWJ7CJyw5Stq4ghXcRmeujr6DwIIj2wJiSVG4dHb0I6jeoHtRddIzO8SGM4BDucSrm6PfNK5bnAWn1Due+TaWoId92U0RTKvy/czICJg4JYkNroIJScmWUYLSAbtR/vLjCpdEIh1yXg4gFy6BpI5TAcoJaotzrBSt4gF94facqWIBC4ZLysxukvicwRLgigMsCa4YwBLh8gOWDJcPMACcP2AgOD9Amn4+QKb2b+qtSftymiLsQvw6GMs2mh3vmC4Bzi+CaYAcOJqoBdzpB1TQtw29/AjqLdYvP+cmijgXCtF0mm4GsoG9lubC7RIQZenyAcm0mcJb2ssRNvdOtLafJpSI5T1eTfS2qw/diP5PXX6ATjQpQgdA38gleocIHiK4G4F/msV5t5Knb62DM7Tn9XGRx7G3Els7SRNVnwtxxjcyxy7SyFIzL+hDiZ8e4JpvP48G9vANflnoRSs7IEmYRk49seTtRjAlJnCMvhx6+Bcecl2AxOvnJgAAAABJRU5ErkJggg==' class='h-[20px] inline'><small> Open in a new tab</small></a>";
                        
    
                    }
    
                    else if (tiles.syntax === "inputbox") {
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                        reg = new RegExp(/\{\{(.*?)\}\}/g);
                        matches = tiles.json.default.match(reg);
                        found;
                        if (matches) {
                            // console.log(tiles.json.tag_name+"test2");
                                for (i = 0; i < matches.length; i++) {
                                found = reg.exec(tiles.json.default);

                                // console.log(tiles.json.tag_name+"test2"+found[1]);
                                
                                    if (this.$data[found[1]]) {
                                        this.dynamic_mergecodes[tiles.json.tag_name] = this.$data[found[1]];
                                    }
                                }
                        } else {
                            // console.log(tiles.json.tag_name);
                            Object.assign(this.$data, { [tiles.json.tag_name]: tiles.json.default});
                        
                                    if (this.$data[tiles.json.tag_name]) {
                                        this.dynamic_mergecodes[tiles.json.tag_name] = this.$data[tiles.json.tag_name];
                                    }
                        }

                        var sanitized_title = "";
                        var sanitized_details = "";
                        /* eslint-disable */
                        sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                        sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                        
                        /* eslint-disable */
                        sanitized_details = tiles.json.details.replace(/\</g,"&lt;")   //for <
                        sanitized_details = sanitized_details.replace(/\>/g,"&gt;")   //for >

                        var input_type = 'text';
                        var input_onkeydown = true;

                        if (tiles.json.input_type == 'text') {
                            input_type = 'text';
                            input_onkeydown = true;
                        } else if (tiles.json.input_type == 'date') { 
                            input_type = 'date';
                            input_onkeydown = false;
                        } else if (tiles.json.input_type == 'time') { 
                            input_type = 'time';
                            input_onkeydown = false;
                        } else if (tiles.json.input_type == 'datetime') { 
                            input_type = 'datetime-local';
                            input_onkeydown = false;
                        } 

                        if (
                            tiles.json.input_type == 'date' ||
                            tiles.json.input_type == 'time' ||
                            tiles.json.input_type == 'datetime'
                        ) {
                            this.validation[tiles.json.tag_name] = {
                                "validation_value":'',
                                "condition":'datetime',
                                "message":'This field is required.',
                                "condition_met":false
                            }

                            str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                sanitized_title+"</label>"
                                +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                tiles.json.placeholder+"' name='"+
                                tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                        
                        } else {
                            if (tiles.json.validation != 'no_validation' && tiles.json.validation != "") {
                                this.validation[tiles.json.tag_name] = {
                                                                        "validation_value":tiles.json.validation_value,
                                                                        "condition":tiles.json.validation,
                                                                        "message":tiles.json.validation_message,
                                                                        "condition_met":false
                                                                        }
                                if (tiles.json.validation_message == "") {
                                    var valid_message = "This field is required.";
                                } else {
                                    valid_message = tiles.json.validation_message;
                                }

                                str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                sanitized_title+"</label>"
                                +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>"+valid_message+"</small></label>"
                                +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                tiles.json.placeholder+"' name='"+
                                tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                            } else if (tiles.json.validation === "" || tiles.json.validation === null) {
                                str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                                sanitized_title+"</label><label>"+
                                sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                tiles.json.placeholder+"' name='"+
                                tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                            } else {
                                str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                                sanitized_title+"</label><label>"+
                                sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                tiles.json.placeholder+"' name='"+
                                tiles.json.tag_name+"' onkeydown='return "+input_onkeydown+"' data-tag='"+tiles.json.tag_name+"' value='"+this.dynamic_mergecodes[tiles.json.tag_name]+"' data-inputtype='"+tiles.syntax+"'>";
                            }
                        }  
                    }
    
                    else if (tiles.syntax === "selectbox") {
                       
                        
                        var sanitized_title = "";
                        var sanitized_desc = "";
                        /* eslint-disable */
                        sanitized_title = tiles.json.title.replace(/\</g,"&lt;")   //for <
                        sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                        sanitized_desc = tiles.json.description.replace(/\</g,"&lt;")   //for <
                        sanitized_desc = sanitized_desc.replace(/\>/g,"&gt;")   //for >

                        if (tiles.json.validation != 'no_validation') {
                            //test fix for badgepack validation
                             if (tiles.json.url) {
                                 if (tiles.json.url.includes('badgepack')) {
                                    this.validation[tiles.json.tag_name] = {
                                        "validation_value":'',
                                        "condition":'badgepack',
                                        "message":'Complete the task.',
                                        "condition_met":false
                                        }

                                    str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>Complete the task.</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_desc+"</label>";
                                 } else {
                                    this.validation[tiles.json.tag_name] = {
                                        "validation_value":'',
                                        "condition":'notnull',
                                        "message":'This field is required.',
                                        "condition_met":false
                                    }

                                    str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_desc+"</label>";     
                                 }
                             } else {
                                 this.validation[tiles.json.tag_name] = {
                                     "validation_value":'',
                                     "condition":'notnull',
                                     "message":'This field is required.',
                                     "condition_met":false
                                     }

                                 str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                 sanitized_title+"</label>"
                                 +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                 +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                 sanitized_desc+"</label>";
                             }

                            //  this.validation[tiles.json.tag_name] = {
                            //                                         "validation_value":'',
                            //                                         "condition":'notnull',
                            //                                         "message":'This field is required.',
                            //                                         "condition_met":false
                            //                                         }

                            // str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                            // tiles.json.title+"</label>"
                            // +"<label id='validator_"+tiles.json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                            // +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                            // tiles.json.description+"</label>";
                        } else {
                            str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                            sanitized_title+"</label><label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                            sanitized_desc+"</label>";
                        }

                        if (tiles.json.url) {
                            if (tiles.json.url.includes('badgepack')) {
                                str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                content = [];
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                               
                                    tiles.json.option_label.map((options, index) => {
                                        // if (tiles.json['url_return'] === 'value') {
                                        //         var hasValue = tiles.json.option_value[index];
                                        // } else if (tiles.json['url_return'] === 'name') {
                                                var hasValue = options;
                                        // }

                                        index = this.bp_integration.map(badge => {
                                             return badge.title; 
                                        }).indexOf(options);

                                        var sanitized_options = "";
                                        var sanitized_value = "";
                                        /* eslint-disable */
                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >


                                        if (this.bp_integration[index]) {
                                            if (this.bp_integration[index].is_checked == 'yes') {
                                                content[index] = "<div class='form-check '>"+
                                                "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='button_bp' value='"+sanitized_value+"'/>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' style='background-color: green; color: white; border: 1px solid white;' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
                                            } else {
                                                content[index] = "<div class='form-check '>"+
                                                "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='button_bp' value='"+sanitized_value+"'/>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' style='color: gray; border: 1px solid gray;' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
                                            }
                                        } else {
                                            content[index] = "<div class='form-check '>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='button_bp' value='"+sanitized_value+"'/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
                                        }
                                        
                                       
                                    });

                                    str_concat_suffix = "</div>"+"</div>"
                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                            } else if (tiles.json.url.includes('uberlist')) { // IF SELECTBOX -> URL -> UBERLIST
                                if (tiles.json.input_type == "radio") {
                                    str_concat_prefix = "<div class=''>"+"<div class='flex flex-wrap '>";
                                    content = [];
                                    this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
    
                                    if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['url_return'] === 'value') {
                                                 var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['url_return'] === 'name') {
                                                    hasValue = options;
                                            } else {
                                                hasValue = options;
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                            
                                            content[index] = "<div class='form-check'>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                sanitized_options+
                                                "</span>"+
                                                "</label>"+
                                                "</div>";
    
                                            
                                        });
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                            
                                    } else {
                                        if (tiles.json.option_label.length > 0) {
                                            tiles.json.option_label.map((options, index) => {
                                                if (tiles.json['option-type'] === 'name_value') {
                                                 var hasValue = tiles.json.option_value[index];
                                                } else if (tiles.json['option-type'] === 'name-only') {
                                                    hasValue = options;
                                                } else {
                                                    hasValue = options;
                                                }

                                                var sanitized_options = "";
                                                var sanitized_value = "";
                                                /* eslint-disable */
                                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                
                                                content[index] = "<div class='form-check'>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                sanitized_options+"</span>"+
                                                    "</label>"+
                                                    "</div>";
                                                });
    
                                                if (tiles.json.allow_other_option === "yes") {
                                                    custom_index = tiles.json.option_label.length;
                                                    // console.log("OTHER:", custom_index);
                                                    content[custom_index] = "<div class='form-check'>"+
                                                    "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                    "<span id='otherLabel"+tiles.json.tag_name+"'>"+
                                                    "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"'data-inputtype='otherBtn' value='Other'/> "+
                                                    "&emsp;Other"+"</span>"+
                                                    "</label>"+
                                                    "</div>";
                                                }
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                            } else {
                                                str_concat_prefix = "<div class='flex'>"+"<div>";
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                            }
                                    } ///OPTION TYPE CLOSE
                                }
            
                                if (tiles.json.input_type == "checkbox") {
                                    str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap '>";
                                    content = [];
                                    this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
    
                                    if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                        tiles.json.option_label.map((options, index) => {
                                            // if (tiles.json['url_return'] === 'value') {
                                                    var hasValue = tiles.json.option_value[index];
                                            // } else if (tiles.json['url_return'] === 'name') {
                                            //         hasValue = options;
                                    
                                            // }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                            
                                            content[index] = "<div class='form-check'>"+
                                            "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
    
                                        });
    
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                            
                                    } else {
                                        if (tiles.json.option_label.length > 0) {
                                            tiles.json.option_label.map((options, index) => {
                                                if (tiles.json['option-type'] === 'name_value') {
                                                    var hasValue = tiles.json.option_value[index];
                                                } else if (tiles.json['option-type'] === 'name-only') {
                                                    hasValue = options;
                                                } else {
                                                    hasValue = options;
                                                }

                                                var sanitized_options = "";
                                                var sanitized_value = "";
                                                /* eslint-disable */
                                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                                
                                                content[index] = "<div class='form-check'>"+
                                                "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
                                                });
    
                                                
                                                // if (tiles.json.allow_other_option === "yes") {
                                                //      custom_index = tiles.json.option_label.length;
                                                //     console.log("OTHER:", custom_index);
                                                //     content[custom_index] = "<div class='form-check'>"+
                                                //     "<label class='labelclass-"+tiles.json.tag_name+custom_index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                //     "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                                //         "<span id='otherLabel"+tiles.json.tag_name+"'>&emsp;Other</span>"+
                                                //         "</label>"+
                                                //         "</div>";
                                                
                                                // }
    
    
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                            } else {
                                                str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                            }
                                    } ///OPTION TYPE CLOSE
                                }
            
                                if ((tiles.json.input_type == "button" || tiles.json.input_type == "name-only")) {
                                    str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                    content = [];
                                    this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                                    if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['url_return'] === 'value') {
                                                 var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['url_return'] === 'name') {
                                                    hasValue = options;
                                            } else {
                                                hasValue = options;
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >

                                            
                                            // hasValue = hasValue.replaceAll("'", "");
                                            content[index] = "<div class='form-check '>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                           "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
    
                                        });

                                        if (tiles.json.allow_other_option === "yes") {
                                            custom_index = tiles.json.option_label.length;
                                            // console.log("OTHER:", custom_index);
                                            content[custom_index] = "<div class='form-check'>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value='Other'/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                            "<span id='otherLabel"+tiles.json.tag_name+"'>Other</span>"+
                                            "</label>"+
                                            "</div>";
                                        }
    
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                            
                                    } else {
                                        if (tiles.json.option_label.length > 0) {
                                            tiles.json.option_label.map((options, index) => {
                                                if (tiles.json['option-type'] === 'name_value') {
                                                 var hasValue = tiles.json.option_value[index];
                                                } else if (tiles.json['option-type'] === 'name-only') {
                                                 hasValue = options;
                    
                                                } else {
                                                  hasValue = options;
                                                }
                                                var sanitized_options = "";
                                                var sanitized_value = "";
                                                /* eslint-disable */
                                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                
                                                // hasValue = hasValue.replaceAll("'", "");
                                                content[index] = "<div class='form-check'>"+
                                                "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
                                            });
    
                                            if (tiles.json.allow_other_option === "yes") {
                                                custom_index = tiles.json.option_label.length;
                                                // console.log("OTHER:", custom_index);
                                                content[custom_index] = "<div class='form-check'>"+
                                                "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value='Other'/>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                "<span><span id='otherLabel"+tiles.json.tag_name+"'>Other</span></span>"+
                                                "</label>"+
                                                "</div>";
                                            }
    
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix; 
                                        } else {
                                            str_concat_prefix = "<div class='flex'>"+"<div>";
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                        }
                                    } ///OPTION TYPE CLOSE
                                } 
                            } else {
                                if (tiles.json.input_type == "radio") {
                                    str_concat_prefix = "<div class=''>"+"<div class='flex flex-wrap '>";
                                    content = [];
                                    this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
    
                                    if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['url_return'] === 'value') {
                                                    var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['url_return'] === 'name') {
                                                    hasValue = options;
                                    
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                            
                                            content[index] = "<div class='form-check'>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
    
                                            
                                        });
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                            
                                    } else {
                                        if (tiles.json.option_label.length > 0) {
                                            tiles.json.option_label.map((options, index) => {
                                                if (tiles.json['option-type'] === 'name_value') {
                                                    var hasValue = tiles.json.option_value[index];
                                                } else if (tiles.json['option-type'] === 'name-only') {
                                                    hasValue = options;
                                                } else {
                                                    hasValue = options;
                                                }

                                                var sanitized_options = "";
                                                var sanitized_value = "";
                                                /* eslint-disable */
                                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                
                                                content[index] = "<div class='form-check'>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
                                                });
    
                                                if (tiles.json.allow_other_option === "yes") {
                                                    custom_index = tiles.json.option_label.length;
                                                    // console.log("OTHER:", custom_index);
                                                    content[custom_index] = "<div class='form-check'>"+
                                                    "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                    "<span id='otherLabel"+tiles.json.tag_name+"'>"+
                                                    "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"'data-inputtype='otherBtn' value='Other'/> "+
                                                    "&emsp;Other"+
                                                    "</span>"+
                                                    "</label>"+
                                                    "</div>";
                                                }
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                            } else {
                                                str_concat_prefix = "<div class='flex'>"+"<div>";
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                            }
                                    } ///OPTION TYPE CLOSE
                                }
            
                                if (tiles.json.input_type == "checkbox") {
                                    str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap '>";
                                    content = [];
                                    this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
    
                                    if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['url_return'] === 'value') {
                                                    var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['url_return'] === 'name') {
                                                    hasValue = options;
                                    
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;") 
                                            
                                            content[index] = "<div class='form-check'>"+
                                            "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                            "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                            sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
    
                                        });
    
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                            
                                    } else {
                                        if (tiles.json.option_label.length > 0) {
                                            tiles.json.option_label.map((options, index) => {
                                                if (tiles.json['option-type'] === 'name_value') {
                                                    var hasValue = tiles.json.option_value[index];
                                                } else if (tiles.json['option-type'] === 'name-only') {
                                                    hasValue = options;
                    
                                                } else {
                                                    hasValue = options;
                                                }

                                                var sanitized_options = "";
                                                var sanitized_value = "";
                                                /* eslint-disable */
                                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;") 

                                                
                                                content[index] = "<div class='form-check'>"+
                                                "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                                sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
                                                });
    
                                                
                                                // if (tiles.json.allow_other_option === "yes") {
                                                //      custom_index = tiles.json.option_label.length;
                                                //     console.log("OTHER:", custom_index);
                                                //     content[custom_index] = "<div class='form-check'>"+
                                                //     "<label class='labelclass-"+tiles.json.tag_name+custom_index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                //     "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                                //         "<span id='otherLabel"+tiles.json.tag_name+"'>&emsp;Other</span>"+
                                                //         "</label>"+
                                                //         "</div>";
                                                
                                                // }
    
    
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                            } else {
                                                str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                                str_concat_suffix = "</div>"+"</div>"
                                                this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                            }
                                    } ///OPTION TYPE CLOSE
                                }
            
                                if ((tiles.json.input_type == "button" || tiles.json.input_type == "name-only")) {
                                    str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                    content = [];
                                    this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                                    if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['url_return'] === 'value') {
                                                    var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['url_return'] === 'name') {
                                                    hasValue = options;
                                    
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                            
                                            // hasValue = hasValue.replaceAll("'", "");
                                            content[index] = "<div class='form-check '>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
    
                                        });
    
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                            
                                    } else {
                                        if (tiles.json.option_label.length > 0) {
                                            tiles.json.option_label.map((options, index) => {
                                                if (tiles.json['option-type'] === 'name_value') {
                                                    var hasValue = tiles.json.option_value[index];
                                                } else if (tiles.json['option-type'] === 'name-only') {
                                                    hasValue = options;
                    
                                                } else {
                                                    hasValue = options;
                                                }

                                                var sanitized_options = "";
                                                var sanitized_value = "";
                                                /* eslint-disable */
                                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                                
                                                // hasValue = hasValue.replaceAll("'", "");
                                                content[index] = "<div class='form-check'>"+
                                                "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                                "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                                "</label>"+
                                                "</div>";
                                            });
    
                                            if (tiles.json.allow_other_option === "yes") {
                                                custom_index = tiles.json.option_label.length;
                                                // console.log("OTHER:", custom_index);
                                                content[custom_index] = "<div class='form-check'>"+
                                                "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value='Other'/>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                "<span><span id='otherLabel"+tiles.json.tag_name+"'>Other</span></span>"+
                                                "</label>"+
                                                "</div>";
                                            }
    
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix; 
                                        } else {
                                            str_concat_prefix = "<div class='flex'>"+"<div>";
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                        }
                                    } ///OPTION TYPE CLOSE
                                } 
                            }
                        } else {
                            if (tiles.json.input_type == "radio") {
                                str_concat_prefix = "<div class=''>"+"<div class='flex flex-wrap '>";
                                content = [];
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});

                                if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                    tiles.json.option_label.map((options, index) => {
                                        if (tiles.json['url_return'] === 'value') {
                                                var hasValue = tiles.json.option_value[index];
                                        } else if (tiles.json['url_return'] === 'name') {
                                                hasValue = options;
                                        } else {
                                            hasValue = options;
                                        }

                                        var sanitized_options = "";
                                        var sanitized_value = "";
                                        /* eslint-disable */
                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                        
                                        content[index] = "<div class='form-check'>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                            "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                            sanitized_options+
                                            "</span>"+
                                            "</label>"+
                                            "</div>";

                                        
                                    });
                                    str_concat_suffix = "</div>"+"</div>"
                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                        
                                } else {
                                    if (tiles.json.option_label.length > 0) {
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['option-type'] === 'name_value') {
                                                var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['option-type'] === 'name-only') {
                                                hasValue = options;
                
                                            } else {
                                                hasValue = options;
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                            
                                            content[index] = "<div class='form-check'>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                            "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                            sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
                                            });

                                            if (tiles.json.allow_other_option === "yes") {
                                                custom_index = tiles.json.option_label.length;
                                                // console.log("OTHER:", custom_index);
                                                content[custom_index] = "<div class='form-check'>"+
                                                "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='rdlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                                "<span id='otherLabel"+tiles.json.tag_name+"'>"+
                                                "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"'data-inputtype='otherBtn' value='Other'/>"+
                                                "&emsp;Other"+
                                                "</span>"+
                                                "</label>"+
                                                "</div>";
                                            }
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                        } else {
                                            str_concat_prefix = "<div class='flex'>"+"<div>";
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                        }
                                } ///OPTION TYPE CLOSE
                            }
        
                            if (tiles.json.input_type == "checkbox") {
                                str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap '>";
                                content = [];
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});

                                if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                    tiles.json.option_label.map((options, index) => {
                                        if (tiles.json['url_return'] === 'value') {
                                                var hasValue = tiles.json.option_value[index];
                                        } else if (tiles.json['url_return'] === 'name') {
                                                hasValue = options;
                                        } else {
                                            hasValue = options;
                                        }

                                        var sanitized_options = "";
                                        var sanitized_value = "";
                                        /* eslint-disable */
                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;") 
                                        
                                        content[index] = "<div class='form-check'>"+
                                        "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                        "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                        sanitized_options+
                                        "</span>"+
                                        "</label>"+
                                        "</div>";

                                    });

                                    str_concat_suffix = "</div>"+"</div>"
                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                        
                                } else {
                                    if (tiles.json.option_label.length > 0) {
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['option-type'] === 'name_value') {
                                                var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['option-type'] === 'name-only') {
                                                hasValue = options;
                
                                            } else {
                                                hasValue = options;
                                            }

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;") 

                                            
                                            content[index] = "<div class='form-check'>"+
                                            "<label class='labelclass-"+tiles.json.tag_name+"-"+index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+
                                            "<input class='radio-label ' id='"+tiles.json.tag_name+"-"+index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/> "+
                                            sanitized_options+
                                            "</span>"+
                                            "</label>"+
                                            "</div>";
                                            });

                                            
                                            // if (tiles.json.allow_other_option === "yes") {
                                            //      custom_index = tiles.json.option_label.length;
                                            //     console.log("OTHER:", custom_index);
                                            //     content[custom_index] = "<div class='form-check'>"+
                                            //     "<label class='labelclass-"+tiles.json.tag_name+custom_index+"-labelclass button-label' id='chkbxlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                            //     "<input class='radio-label ' id='"+tiles.json.tag_name+custom_index+"' type='checkbox' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value=''/>"+
                                            //         "<span id='otherLabel"+tiles.json.tag_name+"'>&emsp;Other</span>"+
                                            //         "</label>"+
                                            //         "</div>";
                                            
                                            // }


                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;
                                        } else {
                                            str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                            str_concat_suffix = "</div>"+"</div>"
                                            this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                        }
                                } ///OPTION TYPE CLOSE
                            }
        
                            if ((tiles.json.input_type == "button" || tiles.json.input_type == "name-only")) {
                                str_concat_prefix = "<div class='flex'>"+"<div class='flex flex-wrap overflow-hidden'>";
                                content = [];
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: []});
                                if (tiles.json['option-type'] === 'url') {   ///OPTION TYPE
                                    tiles.json.option_label.map((options, index) => {
                                        if (tiles.json['url_return'] === 'value') {
                                                var hasValue = tiles.json.option_value[index];
                                        } else if (tiles.json['url_return'] === 'name') {
                                                hasValue = options;
                                        } else {
                                            hasValue = options;
                                        }

                                        
                                        hasValue = hasValue.replaceAll("'", "");

                                        var sanitized_options = "";
                                        var sanitized_value = "";
                                        /* eslint-disable */
                                        sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                        sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                        sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                        sanitized_value = sanitized_value.replace(/\>/g,"&gt;") 

                                        content[index] = "<div class='form-check '>"+
                                        "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                        "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                        "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                        "</label>"+
                                        "</div>";

                                    });

                                    str_concat_suffix = "</div>"+"</div>"
                                    this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix;        
                                        
                                } else {
                                    if (tiles.json.option_label.length > 0) {
                                        tiles.json.option_label.map((options, index) => {
                                            if (tiles.json['option-type'] === 'name_value') {
                                                var hasValue = tiles.json.option_value[index];
                                            } else if (tiles.json['option-type'] === 'name-only') {
                                                hasValue = options;
                                            } else {
                                                hasValue = options;
                                            }

                                            
                                            hasValue = hasValue.replaceAll("'", "");

                                            var sanitized_options = "";
                                            var sanitized_value = "";
                                            /* eslint-disable */
                                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;") 

                                            content[index] = "<div class='form-check'>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+"-"+index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='"+tiles.json.input_type+"' value='"+sanitized_value+"'/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+"-"+index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+"-"+index+"' for='"+tiles.json.tag_name+"-"+index+"'>"+
                                            "<span class='truncate m-0 block ' title='"+sanitized_options+"'>"+sanitized_options+"</span>"+
                                            "</label>"+
                                            "</div>";
                                        });

                                        if (tiles.json.allow_other_option === "yes") {
                                            custom_index = tiles.json.option_label.length;
                                            // console.log("OTHER:", custom_index);
                                            content[custom_index] = "<div class='form-check'>"+
                                            "<input class='radio-label hidden' style='display:none;' id='"+tiles.json.tag_name+custom_index+"' type='radio' name='"+tiles.json.tag_name+"' data-inputtype='otherBtn' value='Other'/>"+
                                            "<label class='radioclass-"+tiles.json.tag_name+custom_index+"-radioclass button-label' id='btnlabel"+tiles.json.tag_name+custom_index+"' for='"+tiles.json.tag_name+custom_index+"'>"+
                                            "<span><span id='otherLabel"+tiles.json.tag_name+"'>Other</span></span>"+
                                            "</label>"+
                                            "</div>";
                                        }

                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+content.join('')+str_concat_suffix; 
                                    } else {
                                        str_concat_prefix = "<div class='flex'>"+"<div>";
                                        str_concat_suffix = "</div>"+"</div>"
                                        this.str_concat = str_concat_prefix+"<small><i>No data found.</i></small>"+str_concat_suffix;
                                    }
                                } ///OPTION TYPE CLOSE
                            } 
                        }
    
                      
                        str = str+this.str_concat;
                    }

                    // else if (tiles.syntax === 'camera') {
                    //     this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [tiles.json.tag_name]: ''});
                    //     str = "<div class='camera'>"+
                    //             "<video autoplay class='feed'></video>"+
                    //             "<center><button class='snap' id='"+tiles.json.tag_name+"'>Snap</button></center>"+
                    //           "</div>";

                    //     if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    //             navigator.mediaDevices.getUserMedia({video: true}).then(stream => {
                    //                 const videoPlayer = document.querySelector("video");
                    //                 videoPlayer.srcObject = stream;
                    //                 videoPlayer.play();
                    //             });
                    //     } else {
                    //         console.log("Cannot get Media Devices");
                    //     }      
                    // }
                }

                
                return str;
            }).join("")
        } else {
            this.tile_loaded = false;
            this.load_current_icon = true;
            return "Tile does not have any user option.";
        }
      
    }
   
    },

    mainFunc (str) {
    var reg = new RegExp(/\{\{(.*?)\}\}/g); //notice /g, making the expression global

    if ((str != 'Loading...') || (str != null) || (str != '') || (str !== undefined)) {

        var matches = str.match(reg);
        var found;

        if (matches) {
            for (var i = 0; i < matches.length; i++) {
                
                found = reg.exec(matches[i]);
                reg.lastIndex = 0;
                
                if (found) {
                    if (this.containsKey(this.$data.dynamic_mergecodes, found[1])) {
                        str = str.replace(found[0], this.$data.dynamic_mergecodes[this.findKey(this.$data.dynamic_mergecodes, found[1])])
                    } else {
                        str = str.replace(found[0], '')
                    }
                }
            }
        }
    }

    
    var modifiedHtmlString = str.replace(/<a\s+([^>]*)href=(['"])(.*?)\2([^>]*)>/gi, '<a $1target="_blank" href=$2$3$2$4>');
    str = modifiedHtmlString;

    // ---- NEW APPROACH: Parse HTML to DOM and modify all IMG tags ----
    const temp = document.createElement('div');
    temp.innerHTML = str;

        // Select ALL images no matter how deep they are
        const imgs = temp.querySelectorAll('img');
        imgs.forEach(img => {
            // Add lightboxable class if not already
            img.classList.add('lightboxable');

            // Add inline centering if needed
            // img.style.display = 'inline-block';
            // img.style.margin = '0 auto';

            // Wrap it in a centered div
            const wrapper = document.createElement('div');
            // wrapper.style.textAlign = 'center';

            img.parentNode.insertBefore(wrapper, img);
            wrapper.appendChild(img);
        });

    return temp.innerHTML;

    },

    prepare_json_submit() {
    Swal.fire({
        title: 'Please wait...',
        html: '<small>Loading...</small>',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
    })

    this.main_data["data"] = [];
            this.$store.getters.active_tile.tile_options.map((tiles) => {
                this.main_data["tile_id"] =  this.$store.getters.active_tile.id;
                var value = this.dynamic_mergecodes[tiles.json.tag_name];

                this.main_data["data"].push({
                    "sort": tiles.sort,
                    "tag": tiles.json.tag,
                    "type": tiles.syntax,
                    "value": value
                });
    })

    

    var today = new Date();
    

    if (
    (this.$store.getters.active_tile.email_to_cloudstaffer === "yes" || 
    this.$store.getters.active_tile.send_to_default_email === "yes" || 
    this.$store.getters.active_tile.send_to_default_mobile === "yes" ||
    this.$store.getters.active_tile.send_to_webhook === "yes" ||
    this.$store.getters.active_tile.has_google_sheet === "yes" ||
    this.$store.getters.active_tile.has_excel === "yes") &&
    (this.url_get_options.length > 0)
    ) {

            var formSubmit = {
                "submit_data": JSON.stringify(this.main_data),
                "token_id": this.$store.getters.auth_token,
                "location": this.ip_location,
                "user_name": this.$store.getters.auth_username,
                "user_domain": window.location.origin,
                "user_guid": this.$store.getters.auth_guid,
                "user_book": this.$store.getters.selected_book,
                "user_page": this.$store.getters.selected_page,
                "user_tile": this.$store.getters.active_tile.title,
                "user_store": this.user_store,
                "user_brand": "Web",
                "date_now": today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate(),
                "time_now": this.getClockTime(),
                "tap_version": this.appVersion,
                "user_public_ip": this.ip_public,
                "user_local_ip": "--",
                "user_data_type": "WIFI",
                "user_wifi_ssid": "HUAWEI-2.4G-g5sA",
                "user_model": "Web",
                "user_email_base64": "",
                "user_version": this.appVersion,
            }

            if (this.file_uploads.length > 0) {
                var formData = new FormData();

                // Append properties from formSubmit2 to the FormData object
                for (const key in formSubmit) {
                if (formSubmit.hasOwnProperty(key)) {
                    formData.append(key, formSubmit[key]);
                }
                }

                // Add file data from file_uploads
                this.file_uploads.forEach(upload => {
                    if (upload.value) {
                    formData.append(`data_${upload.sort}`, upload.value);
                    }
                });
            } else {
                formData = formSubmit;
            }
    
            for (var i=0; i<this.url_get_options.length; i++) {

                var formURLGET = {
                    "current_tile_option": this.url_get_options[i],
                    "submit_data": JSON.stringify(this.main_data),
                    "token_id": this.$store.getters.auth_token,
                    "location": this.ip_location,
                    "user_name": this.$store.getters.auth_username,
                    "user_domain": window.location.origin,
                    "user_guid": this.$store.getters.auth_guid,
                    "user_book": this.$store.getters.selected_book,
                    "user_page": this.$store.getters.selected_page,
                    "user_tile": this.$store.getters.active_tile.title,
                    "date_now": today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate(),
                    "time_now": this.getClockTime(),
                    "tap_version": this.appVersion,
                }

                if (this.file_uploads.length > 0) {
                    var formURLGETData = new FormData();

                    // Append properties from formSubmit2 to the FormData object
                    for (const key in formURLGET) {
                    if (formURLGET.hasOwnProperty(key)) {
                        formURLGETData.append(key, formURLGET[key]);
                    }
                    }

                    // Add file data from file_uploads
                    this.file_uploads.forEach(upload => {
                        if (upload.value) {
                            formURLGETData.append(`data_${upload.sort}`, upload.value);
                        }
                    });
                } else {
                    formURLGETData = formURLGET;
                }

                var urlget_settings = {
                    "url": this.baseAPIURL+"/apiv3/autosend.json",
                    "method": "POST",
                    "timeout": 0,
                    "headers": {
                      "auth": this.$store.getters.auth_token,
                    },
                    "processData": false,
                    "mimeType": "multipart/form-data",
                    "contentType": false,
                    "data": formURLGETData
                };
             
                axios(urlget_settings)
                .then((response) => {
                return response;
                })
                .catch((error) => {
                console.log(error);
                return error;
                });
            }

            var settings = {
                "url": this.baseAPIURL+"/apiv3/submit.json",
                "method": "POST",
                "timeout": 0,
                "headers": {
                  "auth": this.$store.getters.auth_token,
                },
                "processData": false,
                "mimeType": "multipart/form-data",
                "contentType": false,
                "data": formData
            };

            axios(settings)
               .then((response) => {
             
                  this.$store.dispatch('unsetTilesCompleteClear', this.$store.getters.active_tile.id);

                  Swal.close();

                  Swal.fire({
                    title: 'Done!',
                    confirmButtonText: 'Okay',
                    confirmButtonColor: '#2563EB'
                  });

                  this.resetTile();

                  return response;
            })
            .catch((error) => {
              console.log(error);
              if (error.response && error.response.status === 423) {
                  Swal.close();
                  Swal.fire({
                      title: 'Too Many Requests',
                      text: 'You have submitted too many requests. Please wait a moment and try again.',
                      icon: 'warning',
                      confirmButtonText: 'Okay',
                      customClass: {
                          confirmButton: 'px-6 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-blue-600'
                      }
                  });
              }
              return error;
            });
    } else if (
    (this.$store.getters.active_tile.email_to_cloudstaffer === "yes" || 
    this.$store.getters.active_tile.send_to_default_email === "yes" || 
    this.$store.getters.active_tile.send_to_default_mobile === "yes" ||
    this.$store.getters.active_tile.send_to_webhook === "yes" ||
    this.$store.getters.active_tile.has_google_sheet === "yes" ||
    this.$store.getters.active_tile.has_excel === "yes") &&
    (this.url_get_options.length == 0)
    ) {
        var formSubmit2 = { 
            "submit_data": JSON.stringify(this.main_data),
            "token_id": this.$store.getters.auth_token,
            "location": this.ip_location,
            "user_name": this.$store.getters.auth_username,
            "user_domain": window.location.origin,
            "user_guid": this.$store.getters.auth_guid,
            "user_book": this.$store.getters.selected_book,
            "user_page": this.$store.getters.selected_page,
            "user_tile": this.$store.getters.active_tile.title,
            "user_store": this.user_store,
            "user_brand": "Web",
            "date_now": today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate(),
            "time_now": this.getClockTime(),
            "tap_version": this.appVersion,
            "user_public_ip": this.ip_public,
            "user_local_ip": "--",
            "user_data_type": "WIFI",
            "user_wifi_ssid": "HUAWEI-2.4G-g5sA",
            "user_model": "Web",
            "user_email_base64": "",
            "user_version": this.appVersion,
        }

        if (this.file_uploads.length > 0) {
            var formData2 = new FormData();

            // Append properties from formSubmit2 to the FormData object
            for (const key in formSubmit2) {
            if (formSubmit2.hasOwnProperty(key)) {
                formData2.append(key, formSubmit2[key]);
            }
            }

            // Add file data from file_uploads
            this.file_uploads.forEach(upload => {
                if (upload.value) {
                formData2.append(`data_${upload.sort}`, upload.value);
                }
            });
        } else {
            formData2 = formSubmit2;
        }

        var settings = {
            "url": this.baseAPIURL+"/apiv3/submit.json",
            "method": "POST",
            "timeout": 0,
            "headers": {
              "auth": this.$store.getters.auth_token,
            },
            "processData": false,
            "mimeType": "multipart/form-data",
            "contentType": false,
            "data": formData2
        };

        axios(settings)
           .then((response) => {
         
              this.$store.dispatch('unsetTilesCompleteClear', this.$store.getters.active_tile.id);

              Swal.close();
              Swal.fire({
                title: 'Done!',
                confirmButtonText: 'Okay',
                confirmButtonColor: '#2563EB'
              });
              this.resetTile();

              return response;
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status === 423) {
              Swal.close();
              Swal.fire({
                  title: 'Too Many Requests',
                  text: 'You have submitted too many requests. Please wait a moment and try again.',
                  icon: 'warning',
                  confirmButtonText: 'Okay',
                  customClass: {
                      confirmButton: 'px-6 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-blue-600'
                  }
              });
          }
          return error;
        });

    } else if (
        (this.$store.getters.active_tile.email_to_cloudstaffer === "no" && 
        this.$store.getters.active_tile.send_to_default_email === "no" && 
        this.$store.getters.active_tile.send_to_default_mobile === "no" &&
        this.$store.getters.active_tile.send_to_webhook === "no" &&
        this.$store.getters.active_tile.has_google_sheet === "no" &&
        this.$store.getters.active_tile.has_excel === "no") &&
        (this.url_get_options.length > 0)
    ) {

        for (var i=0; i<this.url_get_options.length; i++) {
            var formURLGET2 = {
                "current_tile_option": this.url_get_options[i],
                "submit_data": JSON.stringify(this.main_data),
                "token_id": this.$store.getters.auth_token,
                "location": this.ip_location,
                "user_name": this.$store.getters.auth_username,
                "user_domain": window.location.origin,
                "user_guid": this.$store.getters.auth_guid,
                "user_book": this.$store.getters.selected_book,
                "user_page": this.$store.getters.selected_page,
                "user_tile": this.$store.getters.active_tile.title,
                "date_now": today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate(),
                "time_now": this.getClockTime(),
                "tap_version": this.appVersion,
            }

            if (this.file_uploads.length > 0) {
                var formURLGETDATA = new FormData();

                // Append properties from formSubmit2 to the FormData object
                for (const key in formURLGET2) {
                if (formURLGET2.hasOwnProperty(key)) {
                    formURLGETDATA.append(key, formURLGET2[key]);
                }
                }

                // Add file data from file_uploads
                this.file_uploads.forEach(upload => {
                    if (upload.value) {
                        formURLGETDATA.append(`data_${upload.sort}`, upload.value);
                    }
                });
            } else {
                formURLGETDATA = formURLGET2;
            }
            

            var urlget_settings = {
                "url": this.baseAPIURL+"/apiv3/autosend.json",
                "method": "POST",
                "timeout": 0,
                "headers": {
                  "auth": this.$store.getters.auth_token,
                },
                "processData": false,
                "mimeType": "multipart/form-data",
                "contentType": false,
                "data": formURLGETDATA
            };
         
            axios(urlget_settings)
            .then((response) => {
                this.$store.dispatch('unsetTilesCompleteClear', this.$store.getters.active_tile.id);

                Swal.close();
                Swal.fire({
                    title: 'Done!',
                    confirmButtonText: 'Okay',
                    confirmButtonColor: '#2563EB'
                });
                this.resetTile();

                return response;
            })
            .catch((error) => {
            console.log(error);
            return error;
            });
        }

      
    }

    
    },
};